import { render, staticRenderFns } from "./activeAccount-form.vue?vue&type=template&id=4a249aa9&scoped=true&"
import script from "./activeAccount-form.vue?vue&type=script&lang=js&"
export * from "./activeAccount-form.vue?vue&type=script&lang=js&"
import style0 from "./activeAccount-form.vue?vue&type=style&index=0&id=4a249aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a249aa9",
  null
  
)

export default component.exports